import { addToChainAfter, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import {
    RemoveCartLineApiParameter,
    removeCartLineWithResult as removeCartLineApi,
} from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, RemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { removeFromCartEvent } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartLineId: string;
    },
    RemoveCartLineApiParameter
>;

export const TriggerRemoveFromCartEvent: HandlerType = props => {
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    let itemData = null;
    if (cart?.cartLines && cart?.cartLines?.length) {
        for (let i = 0; i < cart.cartLines.length; i++) {
            if (cart.cartLines[i].id === props.parameter.cartLineId) {
                itemData = {
                    item_id: cart?.cartLines[i].erpNumber,
                    item_name: cart?.cartLines[i].shortDescription,
                    item_brand: cart?.cartLines[i].brand?.name ? cart?.cartLines[i].brand?.name : "",
                    price: cart?.cartLines[i].pricing?.actualPrice,
                    quantity: cart?.cartLines[i].qtyOrdered,
                };
            }
        }
    }
    removeFromCartEvent({
        event: "remove_from_cart",
        ecommerce: {
            currency: "USD",
            value: cart?.orderSubTotal ?? 0,
            items: [itemData],
        },
    });
};

addToChainAfter(chain, RemoveCartLine, TriggerRemoveFromCartEvent);
